import { p as t, g as n } from "./factory-ueRxoNOV.js";
function s({ color: o, theme: r, autoContrast: a }) {
  return (typeof a == "boolean" ? a : r.autoContrast) && t({ color: o || r.primaryColor, theme: r }).isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function e(o, r) {
  return s({
    color: o.colors[o.primaryColor][n(o, r)],
    theme: o,
    autoContrast: null
  });
}
export {
  e as a,
  s as g
};
